import type { ApiError } from '@/api/http';

export interface ApiFailure {
  error: ApiError;
  method: string;
  /** As requested, with ids; the reporter normalises it. */
  path: string;
}

/** What `monitoring/sentry.ts` registers at init. Nothing else in the app imports the SDK. */
export interface MonitoringHooks {
  apiFailure(failure: ApiFailure): void;
  user(id: string | null): void;
}

let hooks: MonitoringHooks | null = null;

export function setMonitoringHooks(next: MonitoringHooks | null): void {
  hooks = next;
}

/** Called once per failed request by `request()`. A reporter failure must never break a request. */
export function reportApiFailure(failure: ApiFailure): void {
  try {
    hooks?.apiFailure(failure);
  } catch {
    // Monitoring is best-effort.
  }
}

export function reportUser(id: string | null): void {
  try {
    hooks?.user(id);
  } catch {
    // Monitoring is best-effort.
  }
}
